import Variant from "@/models/general/settings/RoadcubeMarket/Variant";

export default {
    namespaced: true,

    state: () => ({
        variant: new Variant(),
        variants: [],
        variantsPagination: {total: 12}
    }),

    mutations: {
        setVariants(state, payload) {
            state.variants = payload || [];
        },

        setVariant(state, payload) {
            state.variant = new Variant(payload);
        },
        
        setVariantsPagination(state, payload) {
            state.variantsPagination = payload || [];
        },
    },

    actions: {
        async getVariants({ state, commit }, body) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await Variant.getVariants(body.q);
                    commit("setVariants", data.data.subscription_product_variants);
       
                commit("setVariantsPagination", data.data.pagination);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex?.response?.data);
            }
        },

        async create({ commit, dispatch }, body) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await Variant.createVariant(body);
                commit("setLoading", false, { root: true });
                return data;
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex?.response?.data);
            }
        },

        async update({ commit }, body) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await Variant.updateVariant(
                    body.variant_id,
                    body
                );
                commit("setLoading", false, { root: true });
                return data;
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex?.response?.data);
            }
        },

        async delete({ commit }, id) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await Variant.deleteVariant(id);
                commit("setLoading", false, { root: true });
                return data;
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex?.response?.data);
            }
        }
    }
};
